import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../../_components/common/Navbar';
import SideNavBar from '../../../../_components/common/SideNavBar'
import { superAdminAreaData } from '../../OrgAdminArea/SidebarData'
import UtilityNav from '../../../../_components/common/UtilityNav'
import ModalComponent from '../../../../_components/common/Modal';
import { Table } from 'reactstrap';
import TableNew from '../../../../_components/common/Table';
import { focusAreaText } from './formData';
import { superAdminAction } from '../../../../_actions';


class FocusAreaText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            focusAreaModal: false,
            FocusAreaUpdateMessage: false,
            focusAreaDetails: null,
            navData: [],
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {
        this.props.dispatch(superAdminAction.getFocusAreaTextHandler(() => { }))
        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
    }

    togglefocusAreaModal(showModal) {
        this.setState({
            focusAreaModal: true,
            focusAreaDetails: showModal
        })
    }

    toggleEntireSwotModal(showModal) {
        this.setState({
            focusAreaModal: showModal
        })
    }

    actionSelected(data) {
        const focusAreaDetails = this.state.focusAreaDetails;

        const fd = {
            "text_data": data.data.text_data
        }
        this.props.dispatch(superAdminAction.editFocusAreaTextHandler(focusAreaDetails.id, fd, () => {
            this.setState({ FocusAreaUpdateMessage: true })
        }))
    }


    getHtmlTag(text) {

        let splitData = text.toString().split(`\n`)

        const returnData =
            splitData.map(
                (data, i) => {

                    if (splitData.length === 1) {
                        return < p key={i} > {text}</p >
                    }
                    else {
                        if (data.trim().charAt(0) === '-') {
                            return <li key={i}>{data.trim().substr(1)}</li>
                        }
                        else {
                            return < p key={i} className="mb-1"> {data}</p >
                        }
                    }

                }
            )
        return splitData.length > 1 ? returnData : splitData
    }

    getContent = (id) => {
        const { getFocusAreaTextResponse } = this.props
        for (let i = 0; i < getFocusAreaTextResponse.length; i++) {
            if (getFocusAreaTextResponse[i].id === id) {
                return getFocusAreaTextResponse[i].text_data
            }
        }
    }


    render() {

        const { getFocusAreaTextLoading, getFocusAreaTextResponse } = this.props;

        const tables = {
            data: [{
                name: 'Orientation',
                key: 'orientation__orientation_name',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                headingAlign: false,
                link: ''
            },
            {
                name: 'Attribute',
                key: 'attribute__attribute_name',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                headingAlign: false,
                link: ''
            },
            {
                name: 'Text',
                key: 'text_data',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                headingAlign: true,
                link: ''
            }, {
                name: '',
                key: 'EDIT',
                link: '',
                sort: false,
                type: 'iconButton',
                content: 'fa fa-edit fa-custom',
                alignCenter: true,
                link: '',
                title: 'Edit'

            },
            ]
        }

        let tableData = [];
        getFocusAreaTextResponse !== '' &&
            getFocusAreaTextResponse.map(
                (data, i) => {
                    tableData.push({
                        attribute__attribute_name: data.attribute__attribute_name,
                        atribute_id: data.atribute_id,
                        id: data.id,
                        orientation__orientation_name: data.orientation__orientation_name,
                        orientation_id: data.orientation_id,
                        text_data: this.getHtmlTag(data.text_data),
                    })
                }
            )
       
        this.state.focusAreaModal &&
            focusAreaText.map(
                (data, i) => {
                    data.value = this.getContent(this.state.focusAreaDetails.id)
                    data.valid = true;
                }
            )
        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={superAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">FOCUS AREAS TEXT</h5>

                       
                        <TableNew
                            data={tableData}
                            columns={tables.data}
                            onClickEditIcon={this.togglefocusAreaModal.bind(this)}
                        />
                         {
                            getFocusAreaTextLoading === true &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-dark " ></i>
                                &nbsp;loading
                            </p>
                        }
                        {
                            this.state.focusAreaModal &&
                            <ModalComponent
                                showModal={this.state.focusAreaModal}
                                heading="Focus Areas Text"
                                formData={focusAreaText}
                                action={this.actionSelected.bind(this)}
                                toggleEntireModal={this.toggleEntireSwotModal.bind(this)}
                                footerFormSubmitButton={['Save', 'Cancel']}
                                htmlText={`<div className = " mb-2  d-flex flex-row justify-content-center  col-12 ">
                                <div style="border: 1px solid grey" classname = "col-6 "><p className = "text-center my-2 ">${this.state.focusAreaDetails.orientation__orientation_name}</p></div>  
                                <div style="border: 1px solid grey" classname = "col-6 "><p className = "text-center my-2 ">${this.state.focusAreaDetails.attribute__attribute_name}</p></div></div>`}
                            />
                        }

                        {
                            this.state.FocusAreaUpdateMessage &&
                            <ModalComponent
                                showModal={this.state.FocusAreaUpdateMessage}
                                heading="Focus Area Text"
                                headingIcon="fa fa-check text-white"
                                toggleEntireModal={() => this.setState({ FocusAreaUpdateMessage: false })}
                                htmlText={`<div className = " text-center">
                                                <p className = "font-weight-bold">Success!</p>
                                                <p>Updated successfully.</p>
                                            </div>`}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ FocusAreaUpdateMessage: false })}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}



function mapStateToProps(state) {

    const { getFocusAreaTextLoading } = state.getFocusAreaTextReducer;
    const getFocusAreaTextError = state.getFocusAreaTextReducer.error;
    const getFocusAreaTextResponse = (!getFocusAreaTextLoading && !getFocusAreaTextError) ? state.getFocusAreaTextReducer.data.data.focus_text_list : '';

    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';


    return {
        getFocusAreaTextLoading,
        getFocusAreaTextResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(FocusAreaText);



// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/FocusAreaText/index.js